import { render, staticRenderFns } from "./CarouselManage.vue?vue&type=template&id=0b2400b6&scoped=true&"
import script from "./CarouselManage.vue?vue&type=script&lang=js&"
export * from "./CarouselManage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselManage.vue?vue&type=style&index=0&id=0b2400b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2400b6",
  null
  
)

export default component.exports